// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_PARAINAGES = "GET_PARAINAGES";

// Add PARAINAGE
export const ADD_NEW_PARAINAGE = "ADD_NEW_PARAINAGE";
export const ADD_PARAINAGE_SUCCESS = "ADD_PARAINAGE_SUCCESS";
export const ADD_PARAINAGE_FAIL = "ADD_PARAINAGE_FAIL";

// Edit PARAINAGE
export const UPDATE_PARAINAGE = "UPDATE_PARAINAGE";
export const UPDATE_PARAINAGE_SUCCESS = "UPDATE_PARAINAGE_SUCCESS";
export const UPDATE_PARAINAGE_FAIL = "UPDATE_PARAINAGE_FAIL";
